import { useNavigate, useParams } from 'react-router-dom';
import { FolderOpen } from 'lucide-react';
import DocumentBrowser from '../components/documents/DocumentBrowser';
import Breadcrumbs from '../components/documents/Breadcrumbs';
import useAsync from '../hooks/useAsync';
import folderService from '../services/folderService';

function countLine({ folders, documents }) {
  const parts = [];
  if (folders) parts.push(`${folders} folder${folders === 1 ? '' : 's'}`);
  if (documents) parts.push(`${documents} file${documents === 1 ? '' : 's'}`);
  return parts.join(' · ') || 'Empty';
}

/** v2 browser: breadcrumb, H1 = folder name, muted count line. */
export default function Documents() {
  const { folderId } = useParams();
  const navigate = useNavigate();
  const { data } = useAsync(() => folderService.get(folderId || null), [folderId]);

  const folder = data?.folder;
  const crumbs = data?.breadcrumbs || [{ id: null, name: 'Home' }];

  const header = (counts) => (
    <>
      <Breadcrumbs items={crumbs} onNavigate={(item) => navigate(item.id ? `/documents/${item.id}` : '/documents')} />
      <div className="page-head">
        <div>
          <h1>{folder ? folder.name : 'Documents'}</h1>
          <div className="page-head__sub">
            {folder?.department ? `${folder.department.name} · ` : ''}
            {countLine(counts)}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <DocumentBrowser
      scope="folder"
      folderId={folderId || null}
      departmentId={folder?.department?.id}
      header={header}
      emptyState={{
        icon: FolderOpen,
        title: folder ? `"${folder.name}" is empty` : 'No documents yet',
        body: 'Drag files here, or use Upload to add your first document.',
        folderName: folder ? folder.name : 'Home',
      }}
      onOpenFolder={(item) => navigate(`/documents/${item.id}`)}
    />
  );
}
